<div class="floating-actions-container">
	<!-- Expandable Suggestions Overview -->
	@if (suggestionsCount() > 0) {
		<mat-expansion-panel class="suggestions-expansion-panel">
			<mat-expansion-panel-header class="suggestions-header">
				<mat-panel-title class="suggestions-title-content">
					<span class="suggestions-title">{{
						'suggestions_overview_title' | translate
					}}</span>
					<div class="suggestions-badge">{{ suggestionsCount() }}</div>
				</mat-panel-title>
			</mat-expansion-panel-header>

			<div class="suggestions-content">
				<div class="suggestions-grid">
					@for (suggestion of filteredSuggestions(); track suggestion) {
						<div class="suggestion-item">
							<span class="suggestion-dot">•</span>
							<span class="suggestion-text">{{ suggestion }}</span>
						</div>
					}
				</div>
			</div>
		</mat-expansion-panel>
	}

	<div class="button-wrapper">
		<button mat-stroked-button (click)="onDecline()">
			{{ 'decline' | translate }}
		</button>
		<button mat-flat-button class="primary" (click)="onAccept()">
			<mat-icon svgIcon="smart-stars" />
			{{ 'accept' | translate }}
		</button>
	</div>

	<span class="ai-info-text">{{ 'ai_generated_content_warning' | translate }}</span>
</div>
